<template>
  <div
    class="spinner-container"
    :class="{'spinner-container_full-height': fullHeight}"
    :style="spinnerContainerStyle"
  >
    <div
      v-show="isLoading"
      class="spinner-container__overlay"
    >
      <SmallSpinner
        class="spinner-container__spinner"
        :radius="spinnerRadius"
        :stroke-width="strokeWidth"
        :offset-y="offsetY"
      />
    </div>
    <slot />
  </div>
</template>

<script>
  import SmallSpinner from 'components/common/SmallSpinner';
  export default {
    name: 'SpinnerContainer',
    components: {SmallSpinner},
    props: {
      isLoading: {
        type: Boolean,
        default: false
      },
      spinnerRadius: {
        type: Number,
        default: 20.5
      },
      strokeWidth: {
        type: Number,
        default: 2.5
      },
      offsetY: {
        type: Number,
        default: 0
      },
      fullHeight: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      spinnerHalfSize () {
        return this.spinnerRadius + this.strokeWidth;
      },
      spinnerContainerStyle () {
        return {
          '--spinner-half-size': `${this.spinnerHalfSize}px`,
          '--spinner-offset-y': `${this.offsetY}px`
        };
      }
    }
  };
</script>

<style>
  .spinner-container {
    --spinner-half-size: 23px;
    --spinner-offset-y: 0;

    position: relative;

    width: 100%;
    height: 100%;
  }

  .spinner-container__spinner {
    position: absolute;
    top: calc(50% - var(--spinner-half-size) - var(--spinner-offset-y));
    left: calc(50% - var(--spinner-half-size));

    stroke: var(--main-color);
  }

  .spinner-container__overlay {
    position: absolute;
    z-index: var(--popover-shading-z-index);

    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, 0.5);
  }

  .spinner-container_full-height {
    min-height: 80vh;
  }

</style>
